import type { WasmExportConfig } from "../types/WasmExportConfig"
import { DefaultMinimap as M } from "../maps/DefaultMinimap"
import { InvokeMap } from "../maps/InvokeMap"
import { Stub } from "../types/WasmExportConfig"

/** Default config using DefaultMinimap values. Spread with overrides in CreateWasmLoader. */
export const Minimal: WasmExportConfig = {
  import_module: M.env,
  memory: M.memory,
  indirect_func_table: M.__indirect_function_table,
  wasm_call_ctors: M.__wasm_call_ctors,
  set_threw: M.setThrew,
  stack_get_current: M.emscripten_stack_get_current,
  stack_restore: M._emscripten_stack_restore,
  invokes: InvokeMap,
  stubs: {
    [M._tzset_js]: Stub.noop,
    [M._localtime_js]: Stub.noop,
    [M._gmtime_js]: Stub.noop,
    [M.__syscall_rmdir]: Stub.enoent,
    [M.__syscall_getdents64]: Stub.ebadf_neg,
    [M._emscripten_runtime_keepalive_clear]: Stub.noop,
    [M._setitimer_js]: Stub.zero,
    [M.emscripten_resize_heap]: Stub.resize_heap,
    [M.emscripten_date_now]: Stub.date_now,
    [M._abort_js]: Stub.abort,
    [M._emscripten_throw_longjmp]: Stub.throw_longjmp,
    [M.__syscall_getcwd]: Stub.getcwd,
    [M.__syscall_fcntl64]: Stub.zero,
    [M.__syscall_ioctl]: Stub.zero,
    [M.__syscall_openat]: Stub.enoent,
    [M.__syscall_stat64]: Stub.enoent,
    [M.__syscall_unlinkat]: Stub.enoent,
    [M.__syscall_dup]: Stub.ebadf_neg,
    [M.__syscall_dup3]: Stub.ebadf_neg,
    [M.__syscall_fstat64]: Stub.enoent,
    [M.__syscall_lstat64]: Stub.enoent,
    [M.__syscall_newfstatat]: Stub.enoent,
    [M.__assert_fail]: Stub.assert_fail,
    [M.__cxa_throw]: Stub.cxa_throw,
    [M.exit]: Stub.exit,
  },
  wasi_module: M.wasi_snapshot_preview1,
  wasi_stubs: {
    [M.fd_close]: Stub.ebadf,
    [M.fd_write]: Stub.ebadf,
    [M.fd_read]: Stub.ebadf,
    [M.fd_seek]: Stub.ebadf,
    [M.environ_get]: Stub.zero,
    [M.environ_sizes_get]: Stub.environ_sizes_get,
    [M.proc_exit]: Stub.exit,
    [M.fd_pread]: Stub.ebadf,
    [M.fd_pwrite]: Stub.ebadf,
    [M.clock_time_get]: Stub.zero,
  },
}
